import {
  PRESENCE_LISTEN_REQUEST, PRESENCE_LISTEN_SUCCESS, PRESENCE_LISTEN_FAILURE,
  PRESENCE_SET_REQUEST, PRESENCE_SET_SUCCESS, PRESENCE_SET_FAILURE
} from "./PresenceTypes";

const initial = { items: [], loading: false, error: null, setting: false };

export const presenceReducer = (state = initial, action) => {
  switch (action.type) {
    case PRESENCE_SET_REQUEST: return { ...state, setting: true };
    case PRESENCE_SET_SUCCESS: return { ...state, setting: false };
    case PRESENCE_SET_FAILURE: return { ...state, setting: false, error: action.payload };
    case PRESENCE_LISTEN_REQUEST: return { ...state, loading: true, error: null };
    case PRESENCE_LISTEN_SUCCESS: return { ...state, loading: false, items: action.payload };
    case PRESENCE_LISTEN_FAILURE: return { ...state, loading: false, error: action.payload };
    default: return state;
  }
};